module.exports = __webpack_public_path__ + "static/media/Main_subcontent.5768386a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/Main_subcontent.jpeg
// module id = 212
// module chunks = 0